import React from "react";
import { Paper, Tab, Tabs } from "@material-ui/core/index";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default function TabsNavigator(props) {
  const classes = styles();
  const { value, onTabChange } = props;

  return (
    <Paper square className={classes.container}>
      <Tabs
        value={value}
        className={classes.tab}
        indicatorColor="secondary"
        textColor={"inherit"}
        variant={"fullWidth"}
        onChange={(event, tab) => onTabChange(tab)}
        aria-label="disabled tabs example"
      >
        <Tab label="REPORT" />
        <Tab label="MAPPA" />
        <Tab label="OPERATORI" />
      </Tabs>
    </Paper>
  );
}

const styles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.primary.main
  },
  tab: {
    color: theme.palette.white
  }
}));
